<template>
  <div>
    <v-row dense>
      <v-col v-for="col in 3" :key="col">
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col v-for="col in 5" :key="col">
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-skeleton-loader type="image" transition="fade-transition" />
      </v-col>
    </v-row>
    <v-row dense v-for="row in 3" :key="row">
      <v-col v-for="col in 4" :key="col">
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-skeleton-loader type="image" transition="fade-transition" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "ContactLensTestFormSkeletonLoader",
};
</script>

<style scoped></style>
